module.exports = __webpack_public_path__ + "img/16-girl.66ce3548.svg";